module.exports = __webpack_public_path__ + "static/media/to-printpen.2dde7161.jpg";